import { makeStyles } from '@material-ui/styles'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { NotifyPracticeReasons } from 'consts/giConsts'
import useSelectPatient from 'hooks/useSelectPatient'
import React from 'react'
import { Trans } from 'react-i18next'
import BaseGrinNotification from './BaseGrinNotification/BaseGrinNotification'
import { usePatientFromNotification } from './hooks/usePatientFromNotification'
import NeedsAttentionNotificationTitle from './NeedsAttentionNotificationTitle'

const useStyles = makeStyles({
  note: {
    maxWidth: 250,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
})

/**
 * @param {NotificationComponentProps} props
 */
const NeedsAttentionNotification = ({ grinNotification, options }) => {
  const classes = useStyles()
  const selectPatient = useSelectPatient({
    patientId: grinNotification?.relatedPatientId
  })

  const patient = usePatientFromNotification(grinNotification)
  const isResolved = !!grinNotification?.payload?.resolved
  const senderFirstName = (grinNotification?.payload?.senderName || '').split(' ')[0]

  return (
    <BaseGrinNotification
      grinNotification={grinNotification}
      isLastItem={options.isLastItem}
      showPracticeName={options.showPracticeName}
      profilePicture={patient?.profilePicture}
      profilePictureUserName={patient?.name}
      onClick={selectPatient}
      customTitle={<NeedsAttentionNotificationTitle reason={grinNotification.payload.reason} />}
    >
      <DazzedParagraph14 strong>
        <Trans
          i18nKey={
            isResolved
              ? 'dialogs.notificationCenterDialog.feed.notifications.needsAttention.resolved'
              : grinNotification.payload.reason === NotifyPracticeReasons.SpecificMembersAttention
              ? 'dialogs.notificationCenterDialog.feed.notifications.needsAttention.specificAttention'
              : 'dialogs.notificationCenterDialog.feed.notifications.needsAttention.generic'
          }
          values={{ patientName: patient?.name || 'N/A', senderFirstName }}
        />
      </DazzedParagraph14>
      {grinNotification.payload.note && (
        <DazzedParagraph14 strong className={classes.note}>
          "{grinNotification.payload.note}"
        </DazzedParagraph14>
      )}
    </BaseGrinNotification>
  )
}

export default NeedsAttentionNotification
